/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropReferralEntry
 */
export interface DropReferralEntry {
    /**
     * 
     * @type {string}
     * @memberof DropReferralEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropReferralEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof DropReferralEntry
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof DropReferralEntry
     */
    followedAt?: number;
}

/**
 * Check if a given object implements the DropReferralEntry interface.
 */
export function instanceOfDropReferralEntry(value: object): value is DropReferralEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function DropReferralEntryFromJSON(json: any): DropReferralEntry {
    return DropReferralEntryFromJSONTyped(json, false);
}

export function DropReferralEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropReferralEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'followedAt': json['followedAt'] == null ? undefined : json['followedAt'],
    };
}

export function DropReferralEntryToJSON(json: any): DropReferralEntry {
    return DropReferralEntryToJSONTyped(json, false);
}

export function DropReferralEntryToJSONTyped(value?: DropReferralEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'followedAt': value['followedAt'],
    };
}

